import React from 'react';

import CreateTemplate from '../../Components/Create';
import Erros from './Erros';
import Form from './Form';
import validate from './Validation';

function transform({ nome, tipo, ...data }) {
  return {
    nome,
    cor: '777777',
  };
}

const Create = (props) => (
  <CreateTemplate
    {...props}
    title="Nova Categoria de transação"
    validate={validate}
    onFailure={Erros}
    transform={transform}
    isBack
  >
    <Form />
  </CreateTemplate>
);

export default Create;
